export default "__VITE_ASSET__0b695b90__"